import { useEffect, useState } from "react";
import { getRecommendationsByLegacyBrandId } from "./requests";

export const useGetRecommendations = ({ legacyBrandId }) => {
  const [recommendations, setRecommendations] = useState(null);

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await getRecommendationsByLegacyBrandId(legacyBrandId);
        setRecommendations(response);
      } catch (error) {
        setRecommendations(null);
      }
    };
    void getData();
  }, [legacyBrandId]);

  return {
    recommendations
  };
};
